import { render, staticRenderFns } from "./PriceTableListTable.vue?vue&type=template&id=0056a7f8&scoped=true&lang=html"
import script from "./PriceTableListTable.vue?vue&type=script&lang=js"
export * from "./PriceTableListTable.vue?vue&type=script&lang=js"
import style0 from "./PriceTableListTable.vue?vue&type=style&index=0&id=0056a7f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0056a7f8",
  null
  
)

export default component.exports